import {createContext } from 'react'

const MyContext = createContext(null)


export default MyContext